import flattenMessages from '../../../helpers/flattenMessages';
import en from './en.json';
import ja from './ja.json';

export default {
  en: flattenMessages(en, 'dsar-form'),
  ja: flattenMessages(ja, 'dsar-form'),
};
